module.exports = __webpack_public_path__ + "media/es.00b139d2.mp3";